import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Tooltip,
  Typography,
  useTheme,
  IconButton,
} from "@mui/material";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { getStatusLabel } from "src/Utils/Combined";
import { IOtherBusinessLicense } from "src/Types/module/UpdateRequest/RequestOtherBusinessLicense";

interface IProps {
  otherBusinessLicenseInfo: IOtherBusinessLicense[];
  isLoading: boolean;
}
const OtherBusinessIndex = ({
  isLoading,
  otherBusinessLicenseInfo,
}: IProps) => {
  const theme = useTheme();
  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Company Name</TableCell>
              <TableCell>Company Type</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableLoader />
            ) : otherBusinessLicenseInfo.length ? (
              <>
                {otherBusinessLicenseInfo.map((sOtherBusinessLicense) => {
                  return (
                    <TableRow hover key={sOtherBusinessLicense.request_id}>
                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {sOtherBusinessLicense.member_company_id}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {sOtherBusinessLicense.member_company_name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {sOtherBusinessLicense.member_company_type}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {getStatusLabel(sOtherBusinessLicense.status)}
                      </TableCell>

                      <TableCell>
                        <Link
                          to={`/update-request/other-business-license/${sOtherBusinessLicense.request_id}?memberid=${sOtherBusinessLicense.user_member_id}`}
                        >
                          <Tooltip title="View" arrow={true}>
                            <IconButton
                              sx={{
                                "&:hover": {
                                  background: theme.colors.primary.lighter,
                                },
                                color: theme.palette.primary.main,
                              }}
                              color="inherit"
                              size="small"
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </>
            ) : (
              <TableNotFound />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default OtherBusinessIndex;
